// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { useTransition, animated } from 'react-spring';

const Weeks = (props) => {
  const {
    days,
    selectedDay,
    handleWeekSelect,
    nextPage,
    prevPage,
    daySelect,
    loading,
  } = props;
  const getPrevWeek = () => (prevPage ? (
    <div
      className="arrows left"
      onClick={() => {
        if (!loading.current) handleWeekSelect(prevPage);
      }}
      onKeyPress={() => {
        if (!loading.current) handleWeekSelect(prevPage);
      }}
      role="button"
      type="button"
      tabIndex={0}
      aria-label="previous-week"
    />
  ) : (
    false
  ));
  const getNextWeek = () => (nextPage ? (
    <div
      className="arrows right"
      onClick={() => {
        if (!loading.current) {
          handleWeekSelect(nextPage);
        }
      }}
      onKeyPress={() => {
        if (!loading.current) {
          handleWeekSelect(nextPage);
        }
      }}
      role="button"
      type="button"
      tabIndex={0}
      aria-label="next-week"
    />
  ) : (
    false
  ));
  const handleSelect = (item) => {
    if (item.active) {
      daySelect({
        item,
      });
    }
  };
  const getSelectedClass = (item) => {
    if (item.active) return item.day === selectedDay ? 'day active' : 'day';
    return 'day';
  };

  const transitions = useTransition(days, (item) => `${item.month}${item.day}`, {
    from: { opacity: 0, transform: 'translate3d(15px,0,0)' },
    enter: { opacity: 1, transform: 'translate3d(0,0px,0)' },
    leave: { opacity: 1, transform: 'translate3d(0,0px,0)' },
  });
  return (
    <div className="choice_wrapper">
      {getPrevWeek()}

      <div className="pagination">
        {transitions.map(({ item, props, key }) => (
          <animated.div
            // eslint-disable-next-line react/no-array-index-key
            key={key}
            // style={!loading.current || !item.active ? { outline: '0' } : {}}
            style={props}
            role="button"
            type="button"
            tabIndex={0}
            className={item.active ? 'day-choice_btn' : 'day-disable_btn'}
            onClick={() => {
              if (!loading.current) handleSelect(item);
            }}
            onKeyPress={() => {
              if (!loading.current) handleSelect(item);
            }}
          >
            {item.weekday}
            <br />
            <span className={getSelectedClass(item)}>{item.day}</span>
            {item.monthName}
            <br />
          </animated.div>
        ))}
      </div>
      {getNextWeek()}
    </div>
  );
};

Weeks.propTypes = {
  days: PropTypes.arrayOf(PropTypes.shape().isRequired).isRequired,
  loading: PropTypes.shape({
    current: PropTypes.bool.isRequired,
  }).isRequired,
  daySelect: PropTypes.func.isRequired,
  handleWeekSelect: PropTypes.func.isRequired,
  selectedDay: PropTypes.number.isRequired,
  nextPage: PropTypes.number.isRequired,
  prevPage: PropTypes.number.isRequired,
};
export default Weeks;
